export enum IntakeChaseStatus {
  ACTIVE = 'active',
  NEEDS_ATTENTION = 'needs_attention',
  PAUSED = 'paused',
  COMPLETED = 'completed',
  STOPPED = 'stopped',
}

export enum IntakeChaseMessageStatus {
  PENDING = 'pending',
  SENDING = 'sending',
  SENT = 'sent',
  FAILED = 'failed',
  SKIPPED = 'skipped',
  CANCELLED = 'cancelled',
}

export interface IntakeChaseMessage {
  id: string;
  chase: string;
  day_number: number;
  chase_number: number;
  message_text: string;
  scheduled_at: string; // ISO datetime
  status: IntakeChaseMessageStatus;
  sent_at: string | null;
  failure_reason: string | null;
}

export interface IntakeChase {
  id: string;
  intake: string;
  status: IntakeChaseStatus;
  pc_phone: string;
  pc_timezone: string;
  firm_sms_number: string;
  client_response: string | null;
  client_response_at: string | null;
  started_at: string;
  created_by: string | null;
  messages?: IntakeChaseMessage[];
  // Summary fields from list serializer (available when messages is omitted)
  message_count?: number;
  sent_count?: number;
  failed_count?: number;
  current_day?: number;
  current_chase?: number;
  latest_failure_reason?: string | null;
}

// StartChaseRequest: No body needed, intake ID is in URL
export type StartChaseRequest = Record<string, never>;

export interface UpdateChaseStatusRequest {
  status: 'paused' | 'active' | 'stopped';
}

export interface ChaseScheduleMessagePreview {
  time: string;
  text: string;
}

export interface ChaseScheduleDayPreview {
  day: number;
  messages: ChaseScheduleMessagePreview[];
}

export interface ChaseSchedulePreview {
  total_messages: number;
  total_days: number;
  days: ChaseScheduleDayPreview[];
}
